import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=3c33e14e&scoped=true"
import script from "./privacy_policy.vue?vue&type=script&lang=js"
export * from "./privacy_policy.vue?vue&type=script&lang=js"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=3c33e14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c33e14e",
  null
  
)

export default component.exports